// collection-page.js — mobile filter drawer + price range filter
(function () {
  document.querySelectorAll('[data-bc-filter-drawer]').forEach((drawer) => {
    const section = drawer.closest('.bc-cp');
    if (!section) return;
    const openBtn = section.querySelector('[data-bc-filter-drawer-open]');
    const sidebar = section.querySelector('[data-bc-filter-sidebar]');
    const body = drawer.querySelector('[data-bc-filter-drawer-body]');

    // Clone the sidebar filters into the mobile drawer so they share the same markup
    if (sidebar && body && !body.dataset.filled) {
      body.innerHTML = sidebar.innerHTML;
      body.dataset.filled = 'true';
    }

    if (openBtn) {
      openBtn.addEventListener('click', () => {
        drawer.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
    }

    drawer.querySelectorAll('[data-bc-filter-drawer-close]').forEach((el) => {
      el.addEventListener('click', () => {
        drawer.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
  });

  // Price range: apply on Enter key by rebuilding the URL with min/max params
  document.querySelectorAll('[id^="bc-filter-price-min-"]').forEach((minInput) => {
    const id = minInput.id.replace('bc-filter-price-min-', '');
    const maxInput = document.getElementById('bc-filter-price-max-' + id);
    if (!maxInput) return;

    function applyPriceFilter() {
      const url = new URL(window.location.href);
      if (minInput.value) url.searchParams.set('filter.v.price.gte', minInput.value);
      if (maxInput.value) url.searchParams.set('filter.v.price.lte', maxInput.value);
      window.location.href = url.toString();
    }

    [minInput, maxInput].forEach((input) => {
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') applyPriceFilter();
      });
    });
  });
})();
